import { ApiService } from './api.service';
import { CustomValidator } from './custom.validator';

import { DialogActionService } from './dialog-actions.service';
import { DialogConfirmService } from './dialog-confirm.service';
import { DialogDeleteService } from './dialog-delete.service';

import { CustomHttpInterceptor } from './intercept.service';
import { LoaderService } from './loader.service';
import { SharedService } from './shared.service';
import { SnackBarService } from './snackbar.service';
import { StorageService } from './storage.service';
import { SweetAlert } from './sweetalet.service';
import { CommonServices } from './common.service';
import { MapService } from './map.service';
import { KDTreeService } from './kdtree.service';
import { FileUploadService } from './file-upload.service';
import { SubService } from './sub.service';

import { BreadcrumbService } from './breadcrumb.service';
// import { DialogActionService } from './dialog-actions.service';
// import { DialogDeleteService } from './dialog-delete.service';
import { ExcelExportService } from './excel.service';
// import { CustomHttpInterceptor } from './intercept.service';
// import { LoaderService } from './loader.service';
// import { RouteService } from './route.service';
import { S3BudgetService } from './s3Budget.service';
// import {  } from './shared.service';
// import {  } from './snackbar.service';
import { SocketIOService } from './socket.io.service';
// import {  } from './storage.service';
// import {  } from './'; 
import { RouteService } from "./route.service";
import { SubjectService } from './subject-services';

export const ServiceDeclaration = [
    ApiService,
    StorageService,
    CustomValidator,
    DialogActionService,
    DialogConfirmService,
    ExcelExportService,
    SharedService,
    SnackBarService,
    SweetAlert,
    DialogDeleteService,
    CustomHttpInterceptor,
    LoaderService,
    CommonServices,
    MapService,
    KDTreeService,
    SocketIOService,
    FileUploadService,
    S3BudgetService,
    RouteService,
    BreadcrumbService,
    ExcelExportService,
    SubService,
    SubjectService
    
];
